import { registerErrorHandler } from '@piri/error';
import { DialogColors } from '@/components/dialogs/constants';

import AlertError from './AlertError';

const alertErrorHandler = error => {
  window.app.$alert(window.app.$t(window.app.$lang.app.ERROR), error.message, {
    color: DialogColors.ERROR,
  });
};

registerErrorHandler(AlertError.key, alertErrorHandler);
